import { Text } from '@radix-ui/themes';
import type { ReactNode } from 'react';

export const EditorField = ({ label, children }: { label: string; children: ReactNode }) => (
  <div>
    <Text as="label" size="2" weight="bold">
      {label}
    </Text>
    {children}
  </div>
);
